(function() {
  if (App.angularApp == null) {
    return;
  }

  App.angularApp.directive('mfMentionInput', function() {
    return {
      restrict: 'A',
      require: ['^mfMentionContainer'],
      link: (function(_this) {
        return function(scope, elem, attrs, ctrls) {
          var Cont, Model;
          Cont = ctrls[0];
          Model = ctrls[1];
          Cont.input_elem = elem;
          return scope.$watch(function() {
            return elem.val();
          }, function(val) {
            var match;
            if (val.slice(-1) === '@' || Cont.get('is_open')) {
              match = val.match(/(^|\s)@([\S]*)$/);
              return Cont.setPattern(match != null ? match[2] : void 0, (match != null ? match[2] : void 0) != null);
            }
          });
        };
      })(this)
    };
  });

}).call(this);
